module.exports = __webpack_public_path__ + "images/STACK_TOP.png?v=f0079d89291a7776c868267bde410f4e";